const BRAND = `${process.env.PUBLIC_URL}/brand`;

/* Official TAVONX brand assets (from the TAVONX brand deck) */
export const XMark = ({ className = "h-6 w-auto" }) => (
    <img
        src={`${BRAND}/tavonx-x@3x.png`}
        alt=""
        aria-hidden="true"
        draggable={false}
        className={`select-none object-contain ${className}`}
    />
);

export const Logo = ({ sub = null, onClick }) => (
    <a
        href="#hero"
        onClick={onClick}
        data-testid="nav-logo"
        className="group relative flex items-center gap-3 before:absolute before:-inset-y-3 before:-inset-x-2 before:content-['']"
        aria-label="TAVONX home"
    >
        <img
            src={`${BRAND}/tavonx-lockup.png`}
            alt="TAVONX"
            draggable={false}
            className="h-8 w-auto select-none transition-opacity duration-300 group-hover:opacity-80 lg:h-9"
        />
        {sub && (
            <span className="hidden border-l border-white/10 pl-3 font-mono text-[9px] uppercase tracking-[0.34em] text-slate-500 sm:block">
                {sub}
            </span>
        )}
    </a>
);
